import React, { useEffect, useRef } from 'react';
import { useServerError } from '../../contexts/ServerErrorContext';
import { checkServerHealth } from '../../utils/healthCheck';

const ServerError = () => {
  const { isServerError, clearServerError, errorMessage } = useServerError();
  const intervalRef = useRef(null);

  // Poll for server health every 5 seconds when server error is shown
  useEffect(() => {
    if (isServerError) {
      // Check immediately first
      const checkHealth = async () => {
        try {
          const isHealthy = await checkServerHealth();
          if (isHealthy) {
            // Server is back! Reload the page automatically
            // window.location.reload();
            clearServerError();
          }
        } catch (error) {
          // Server still down, continue polling
        }
      };

      // Check immediately
      checkHealth();

      // Then check every 5 seconds
      intervalRef.current = setInterval(checkHealth, 5000);

      return () => {
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
        }
      };
    } else {
      // Clear interval if error is cleared
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    }
  }, [isServerError, clearServerError]);

  if (!isServerError) return null;

  const handleRefresh = () => {
    window.location.reload();
  };

  // Function to render text with "Refresh" (case-insensitive) in bold
  const renderMessageWithBoldRefresh = (message) => {
    if (!message) return null;
    
    const regex = /(refresh)/gi;
    const parts = message.split(regex);
    
    return parts.map((part, index) => {
      // Check if the part matches "refresh" (case-insensitive)
      if (part.toLowerCase() === 'refresh') {
        return <strong key={index} className="font-bold">{part}</strong>;
      }
      return <React.Fragment key={index}>{part}</React.Fragment>;
    });
  };

  const displayMessage = errorMessage || "Something Went Wrong. Please refresh page.";

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-75">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4 p-6 text-center">
        <div className="mb-4">
          <svg
            className="mx-auto h-16 w-16 text-red-500"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            />
          </svg>
        </div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2">
         Network Error
        </h2>
        <p className="text-gray-600 mb-6">
          {renderMessageWithBoldRefresh(displayMessage)}
        </p>
        <div className="flex gap-3 justify-center">
          <button
            onClick={handleRefresh}
            className="px-6 py-2 text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-offset-2 transition-all hover:opacity-90"
            style={{
              background: 'linear-gradient(5.12deg, rgb(239, 154, 25) -0.37%, rgb(255, 201, 56) 108.9%)'
            }}
          >
            Refresh Page
          </button>
          <button
            onClick={clearServerError}
            className="px-6 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ServerError;

